import type { SettlementBatch } from "./types";
import { calculateSettlementAmounts, settlementAdjustmentAmounts } from "./settlementAmounts";

/** Full saved batch snapshots, independent of record pagination and column filters. */
export function payrollBatchWorkerTotals(batch: SettlementBatch) {
  const transfers = new Map(batch.transfers.map(row => [row.workerId, row]));
  const workers = new Map(batch.messages.map(message => {
    let gross = 0, deduction = 0, addition = 0, manual = 0;
    for (const item of message.workItems) {
      gross += item.grossAmount; manual += item.manualAmount ?? 0;
      const adjustment = settlementAdjustmentAmounts(item);
      deduction += adjustment.deductionAmount; addition += adjustment.additionAmount;
    }
    const amounts = calculateSettlementAmounts(gross, deduction, addition);
    return [message.workerId, { workerId: message.workerId, name: message.workerName,
      taxableGross: amounts.taxableGrossAmount, manual,
      // Stored transfers are authoritative, including legacy batches with historic rounding.
      payable: transfers.get(message.workerId)?.amount ?? 0 }];
  }));
  for (const transfer of batch.transfers) if (!workers.has(transfer.workerId)) workers.set(transfer.workerId,
    { workerId: transfer.workerId, name: transfer.workerName, taxableGross: 0, manual: 0, payable: transfer.amount });
  return [...workers.values()].sort((a, b) => a.name.localeCompare(b.name, "ko") || a.workerId.localeCompare(b.workerId));
}
